<template>
  <div
    class="relative flex w-full overflow-hidden rounded-md bg-gray-200"
    :class="{
      'h-1-25': small,
      'h-4': medium,
      'h-7': !small && !medium,
    }"
    data-cy="scorecard-points-bar"
  >
    <template v-if="!!categoriesWithWidth.length">
      <div
        v-for="(category, index) in categoriesWithWidth"
        :key="category.color || index"
        class="flex h-full items-center justify-center border-r border-white last:border-0"
        :style="{
          width: category.width,
          backgroundColor:
            category.color ??
            SCORECARD_COLOR_SWATCHES[index % SCORECARD_COLOR_SWATCHES.length],
        }"
      >
        <span v-if="showPercentage" :class="getTextClass(category.color || '')">
          {{
            category.width.indexOf(".") > -1
              ? `${parseFloat(category.width).toFixed(2)}%`
              : category.width
          }}
        </span>
      </div>
    </template>
    <div
      v-else
      class="flex h-full w-full items-center justify-center bg-gray-200 text-xxs font-semibold uppercase"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getTextClass } from "@/helpers/UI";
import { SCORECARD_COLOR_SWATCHES } from "@/helpers/constants";

import type {
  IScorecardContentCategory,
  ScorecardGroupPreview,
} from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  categories: {
    type: Array as PropType<IScorecardContentCategory[]>,
    default: () => [],
  },
  scorecards: {
    type: Array as PropType<ScorecardGroupPreview[] | null>,
    default: null,
  },
  total: {
    type: Number,
    default: 1,
  },
  small: {
    type: Boolean,
    default: false,
  },
  medium: {
    type: Boolean,
    default: false,
  },
  tileSmall: {
    type: Boolean,
    default: false,
  },
  showPercentage: {
    type: Boolean,
    default: false,
  },
});

const categoriesWithWidth = computed(() => {
  const source = props.scorecards || props.categories;
  return source.map(({ points, ...rest }) => {
    let pointsSource = points;
    if ("group_weight" in rest) {
      pointsSource = rest.group_weight || 0;
    }
    const width = ((pointsSource || 0) / (props.total || 1)) * 100;
    return {
      ...rest,
      pointsSource,
      width: width === 0 ? "" : `${width}%`,
    };
  });
});
</script>
